import { Box, Spinner } from "@chakra-ui/react";
import ComplaintsMapLayer from "components/Organismos/ComplaintsMapLayer";
import { Map } from "components/Organismos/Map";
import PostsMapLayer from "components/Organismos/PostMapLayer";
import { Breadcrumb } from "layouts/LayoutDefault/Breadcrumb";
import { FeatureGroup as LeafletFeatureGroup, LatLng, Map as LeafletMap } from "leaflet";
import { useEffect, useRef, useState } from "react";
import { FeatureGroup, TileLayer } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { getComplaintsGeojsonRequest } from "store/modules/complaints/actions/getComplaintsGeojson";
import { getEssentialServicesGeojsonRequest } from "store/modules/posts/actions/getEssentialServicesGeojson";
import { getInformativesGeojsonRequest } from "store/modules/posts/actions/getInformativesGeojson";

const initialLatLng = new LatLng(1.252367, -51.946561);

export const Home = () => {
  const featureRef = useRef<LeafletFeatureGroup>(null);
  const [map, setMap] = useState<LeafletMap>();
  const navigate = useNavigate();
  const {
    isRequesting: loadingInformatives,
    successPayload: informatives
  } = useTypedSelector(state => state.posts.getInformativesGeojson);

  const {
    isRequesting: loadingEssentialServices,
    successPayload: essentialServices
  } = useTypedSelector(state => state.posts.getEssentialServicesGeojson);

  const {
    isRequesting: loadingComplaints,
    successPayload: complaints
  } = useTypedSelector(state => state.complaints.getComplaintsGeojson);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getInformativesGeojsonRequest());
    dispatch(getEssentialServicesGeojsonRequest());
    dispatch(getComplaintsGeojsonRequest({ showOnlyUser: false }));
  }, []);

  // useEffect(() => {
  //   if (map && featureRef.current) {
  //     const bounds = featureRef.current.getBounds();
  //     if (bounds.isValid()) {
  //       map.fitBounds(bounds);
  //     }
  //   }
  // }, [map, informatives, complaints, essentialServices]);

  return (
    <Box h="full">
      <Breadcrumb paths={[{ name: "Início" }]} />
      {(loadingInformatives || loadingEssentialServices || loadingComplaints) && (
        <Spinner position="absolute" zIndex={9999999} />
      )}
      <Map
        center={initialLatLng}
        zoom={7}
        zoomControl
        whenCreated={(ref) => setMap(ref)}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FeatureGroup ref={featureRef}>
          {informatives && (
            <PostsMapLayer
              postType="Informativo"
              features={informatives.features}
              onEditClick={(properties) => navigate(`/posts?showPostForm=true&postId=${properties.Id}&post_type=INFORMATIVO`)}
            />
          )}

          {essentialServices && (
            <PostsMapLayer
              postType="Ponto essencial"
              features={essentialServices.features}
              onEditClick={(properties) => navigate(`/posts?showPostForm=true&postId=${properties.Id}&post_type=PONTO_ESSENCIAL`)}
            />
          )}

          {complaints && (
            <ComplaintsMapLayer
              features={complaints.features}
              onViewClick={(properties) => navigate(`/complaints?showDetailsComplaint=true&complaintId=${properties.Id}`)}
            />
          )}
        </FeatureGroup>
      </Map>
    </Box>
  );
};
